import React from "react";
import { ErrorPage } from "core/config/routing/pages/globalPages";
// import ReactLoader from "../utils/loader";
import { default as PageTypes } from "core/config/routing/pageTypes";
import { isUndefined } from "core/helpers/functions";
import { Redirect } from "react-router-dom";
import PageErrorBoundary from "./page-error-boundary";

const DynamicRouter = (props) => {
  if (props?.variables?.url.endsWith("/")) {
    let finalLink = props.variables.url.slice(0, -1);
    return <Redirect to={`/${finalLink}`} />;
  }
  if(props?.data?.urlResolver?.type === "CATEGORY"){
    const urlResolver = props.data.urlResolver;
    const Page = PageTypes[urlResolver.type];

    return (
        <PageErrorBoundary key={props.variables.url}>
            <Page
                {...props}
                id={urlResolver.id}
                sku={urlResolver?.sku}
                url={props.variables.url}
                variables={{ id: urlResolver.id, url: props.variables.url }}
            />
        </PageErrorBoundary>
    );
  }

  if (!props.data || !props.data.route) {
    if (!props.isCached) return <div>{/* <ReactLoader /> */}</div>;
  }

  if (!isUndefined(props.data) && !isUndefined(props.data.route)) {
    const urlResolver = props.data.route;
    if (urlResolver !== null && PageTypes.hasOwnProperty(urlResolver.type)) {
      const Page = PageTypes[urlResolver.type];

      return (
        <PageErrorBoundary key={props.variables.url}>
          <Page
            {...props}
            id={urlResolver.id}
            sku={urlResolver?.sku}
            url={props.variables.url}
            variables={{ id: urlResolver.id, url: props.variables.url }}
          />
        </PageErrorBoundary>
      );
    }
  }
  if (isUndefined(props.data)) {
    return <>Loading...</>;
  }

  return <ErrorPage />;
};

export default DynamicRouter;
